export default __webpack_public_path__ + "static/Refining_Forge-65631946546a73e2c17a29cfa3cdf47d.png";